import { IconButton, IconButtonProps, styled } from '@mui/material';

export const CerebroIconButton: React.FC<CerebroIconButtonProps> = ({ children, sx, ...props }) => {
  return (
    <StyledIconButton {...props} sx={sx}>
      {children}
    </StyledIconButton>
  );
};

type CerebroIconButtonProps = IconButtonProps;

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.gray.dark,
  marginLeft: theme.spacing(1.5), 
  '&:hover': {
    color: theme.palette.error.dark,
  },
}));
